import React from 'react';
import { Button } from '../ui/button';
import { RotateCcw, X, Save } from 'lucide-react';

function timeAgo(iso) {
  if (!iso) return '';
  const diff = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return new Date(iso).toLocaleDateString();
}

/** Small amber banner shown at the top of a manager when an unsaved draft
 * from a previous session exists in localStorage. */
const DraftBanner = ({ draftAt, onRestore, onDiscard, testid = 'draft-banner' }) => (
  <div
    className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    data-testid={testid}
  >
    <div className="flex items-start gap-2">
      <Save className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <div>
        <div className="font-semibold">Unsaved draft found ({timeAgo(draftAt)})</div>
        <div className="text-amber-800/90">
          You closed the tab with unsaved edits. Restore them, or discard to keep the current server version.
        </div>
      </div>
    </div>
    <div className="flex items-center gap-2 ml-auto">
      <Button size="sm" onClick={onRestore} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid={`${testid}-restore`}>
        <RotateCcw className="w-3.5 h-3.5 mr-1" /> Restore draft
      </Button>
      <Button size="sm" variant="outline" onClick={onDiscard} data-testid={`${testid}-discard`}>
        <X className="w-3.5 h-3.5 mr-1" /> Discard
      </Button>
    </div>
  </div>
);

export default DraftBanner;
